<script>
export default {
  props: {
    member: {
      type: Object,
      required: true,
    },
    isOwner:{
      type: Boolean,
      default: false
    },
    showRemove:{
      type: Boolean,
      default: false
    }
  },
}
</script>
<template>
  <el-row class="mini-member-card d-flex align-items-center">
    <el-col
      :xs="4"
      :sm="3"
    >
      <el-avatar
        shape="circle"
        class="avatar"
        :size="40"
        :src="member.avatar"
      ></el-avatar>
    </el-col>
    <el-col
      :xs="14"
      :sm="12"
    >
      <h4 class="mb-1">
        {{ `${member.full_name } ${isOwner ?' ( Owner )' : ''}` }}
      </h4>
      <h4 class="mb-0 mt-1 details">
        {{ member.role }} <span v-if="member.role && member.organisation_name">|</span> {{ member.organisation_name }}
      </h4>
    </el-col>
    <el-col 
      :xs="6"
      :sm="8"
    >
      <div
        v-if="!isOwner && showRemove"
        class="font-weight-bold button-link pull-right"
        @click="$emit('remove-member', member)"
      >
        Remove
      </div>
      <router-link
        v-else-if="!showRemove"
        class="font-weight-bold button-link pull-right"
        :to="{
          name: 'Member Profile',
          params: { id: member.id },
        }"
      >
        View profile
      </router-link>
    </el-col>
  </el-row>
</template>
<style lang="scss">
.mini-member-card{
  border-bottom: 1px solid #D9D9D9;
  padding: 15px 0;
  h4.details{
    color: #000000;
  }
  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }
  .mark-as-owner{
    text-decoration: underline;
    &:hover{
      text-decoration: none;
    }
  }
}
</style>
